import { render } from "./MainSpeedDial.vue?vue&type=template&id=bb9d3f12"
import script from "./MainSpeedDial.vue?vue&type=script&lang=js"
export * from "./MainSpeedDial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__